import React from 'react';
import styled, { useTheme } from 'styled-components';
import ReactJson from 'react-json-view';

const StyledReactJsonWrapper = styled.div`
  font-size: 10px;
  .variable-row,
  .object-key-val {
    position: relative;
    .copy-to-clipboard-container {
      position: absolute;
    }
  }
`;

interface RawJsonProps {
  json: Record<string, unknown> | unknown[];
  objectRootName?: string | null;
}

export const RawJson = ({ json, objectRootName }: RawJsonProps) => {
  const theme = useTheme();

  return (
    <StyledReactJsonWrapper>
      <ReactJson
        name={objectRootName}
        displayDataTypes={false}
        groupArraysAfterLength={10}
        iconStyle="square"
        src={json}
        enableClipboard={(e) =>
          typeof e.src === 'string'
            ? navigator.clipboard.writeText(e.src)
            : e.src
        }
        theme={{
          base00: theme.styleguideColors.backgroundPrimary,
          base01: theme.styleguideColors.backgroundPrimary,
          base02: theme.styleguideColors.borderSecondary,
          base03: theme.styleguideColors.contentPrimary,
          base04: theme.styleguideColors.contentTertiary,
          base05: theme.styleguideColors.contentPrimary,
          base06: theme.styleguideColors.contentPrimary,
          base07: theme.styleguideColors.contentPrimary,
          base08: theme.styleguideColors.contentPrimary,
          base09: theme.styleguideColors.contentRed,
          base0A: theme.styleguideColors.contentRed,
          base0B: theme.styleguideColors.contentRed,
          base0C: theme.styleguideColors.contentBlue,
          base0D: theme.styleguideColors.contentRed,
          base0E: theme.styleguideColors.contentRed,
          base0F: theme.styleguideColors.contentLightBlue,
        }}
      />
    </StyledReactJsonWrapper>
  );
};
